"use client";

import { Button } from "@yardzen/ui/components/button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@yardzen/ui/components/dialog";
import { VisuallyHidden } from "@yardzen/ui/components/visually-hidden";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { InlineWidget } from "react-calendly";

export interface ClientUserData {
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
}

function parseUrl(path: string) {
  switch (path) {
    case "/residential-development":
      return "https://calendly.com/d/csf8-5c3-z7d/yardzen-residential-development-consult-call";
    case "/commercial-development":
      return "https://calendly.com/d/cshs-hw6-tw4/yardzen-commercial-project-consult-call";
    default:
      return "https://calendly.com/d/cqks-48t-ckd/project-consultation-with-yardzen";
  }
}

export default function ClientCalendlyPopup() {
  const path = usePathname();
  const url = parseUrl(path);

  const [rootElement, setRootElement] = useState<HTMLElement | null>(null);
  console.log(path);
  useEffect(() => {
    setRootElement(document.getElementById("root"));
  }, []);

  // Don't render until we have the root element
  if (!rootElement) {
    return null;
  }

  return (
    <Dialog>
      <VisuallyHidden>
        <DialogTitle>Schedule a Free Call with Yardzen</DialogTitle>
      </VisuallyHidden>
      <DialogTrigger asChild>
        <Button
          id="calendly-popup-button"
          className="w-15 h-15 fixed bottom-5 right-5 z-50 drop-shadow-md"
        >
          Schedule a Free Call
        </Button>
      </DialogTrigger>
      <DialogContent
        className="!p-0 md:!h-full md:!max-h-[700px] md:!max-w-7xl"
        dialogCloseClassName="!top-2 !right-2"
      >
        <InlineWidget url={url} styles={{ height: "700px" }} />
      </DialogContent>
    </Dialog>
  );
}
